import React from "react";

import "./training-policies-sidebar.styles.scss";
import Skeleton from "react-loading-skeleton";

const TrainingPolices = ({buttonText, trainingPolicyContent}) => {
    return (
        <div class="cart-sidebar">
            {
                trainingPolicyContent
                    ? <div dangerouslySetInnerHTML={{__html: trainingPolicyContent}}/>
                    : <Skeleton height={200}/>
            }
        </div>
    );
};

export default TrainingPolices;
